import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import * as XLSX from 'xlsx';
import { ConfirmReservationDialogComponent } from '../dialogs/confirm-reservation-dialog/confirm-reservation-dialog.component';
import { finalize, map } from 'rxjs/operators';
import { FirebaseStorageService } from 'src/app/services/firebase-storage.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-upload-images',
  templateUrl: './upload-images.component.html',
  styleUrls: ['./upload-images.component.sass']
})
export class UploadImagesComponent implements OnInit {
  type_accept: string = '.jpg, .jpeg, .png';
  selectedFiles: File = null;
  studentForm: FormGroup;
  stages: any;
  stagesListSubs: Subscription;
  private routeSub: Subscription;
  gradesListSubs: Subscription;
  grades: any;
  title: string;
  message: string;
  ok_txt: string;
  showPrimarySpinner: boolean = false;
  files: any[] = [];
  files_list: any[] = [];


  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private translate: TranslateService,
    public firebaseStorageService: FirebaseStorageService,
    private snackbar: MatSnackBar

  ) { }

  public getStages(schoolID: string) {
    this.stages = [{ 'id': null, 'name': "" }]
    this.grades = [{ 'id': null, 'name': "" }]
    this.studentForm.controls["stages"].setValue('')
    this.studentForm.controls["grades"].setValue('')
    // this.studentForm.controls["lines"].setValue('')

    this.stagesListSubs = this.dataService
      .getStages(schoolID)
      .subscribe(res => {
        this.stages = res;
        this.stages = [{ 'id': null, 'name': "" }].concat(this.stages)
        // this.studentForm.controls["stages"].setValue(res[0]['id'])
        // this.getGrades(res[0]['id'])
      },
        console.error
      );
  }

  public getGrades(stageID: string) {
    this.studentForm.controls["grades"].setValue('')

    var params = {}
    params['school_id'] = ''
    params['stage_id'] = stageID

    this.gradesListSubs = this.dataService
      .getGrades(params)
      .subscribe(res => {
        this.grades = res;
        this.grades = [{ 'id': null, 'name': "" }].concat(this.grades)
        // this.studentForm.controls["grades"].setValue(res[0]['id'])
        // this.getLines(res[0]['id'])
      },
        console.error
      );
  }

  ngOnInit() {
    this.studentForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      stages: new FormControl('', Validators.required),
      grades: new FormControl('', Validators.required),
    });

    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')){
        this.router.navigate(['/welcome']);
      }

    });
    this.routeSub = this.route.params.subscribe(params => {
      if (params.id_school) {
        
        this.getStages(params.id_school)

      }
    })
  }

  public async uploadImages() {

    // Exit if file list is empty
    if(this.files.length<=0) {
      let msg = await this.translate.get('alerts.images_required').toPromise();
      this.snackbar.openFromComponent(CustomPopupComponent, { data: msg, duration: 4000, panelClass: "error-snackbar" });
      return;
    }


    // Separate files by file name (A -> list A , B -> list B)
    const fileList = this.files
    let fileListA = []
    let fileListB = []
    let schoolId = this.route.snapshot.paramMap.get('id_school')

    fileList.forEach((file: any) => {
      let isPrimaryPhoto: boolean = file.name.toUpperCase().split(".")[0].slice(-1) == "A"
      isPrimaryPhoto ? fileListA.push(file) : fileListB.push(file)
    })

    // Index for visual loading bar
    let index = 0

    // Counter to check when all async methods have finished
    let counter = fileListA.length

    // Upload & assign primary photos
    for(let i = 0; i < fileListA.length; i++) {
      let name = fileListA[i].name.toUpperCase().split(".")
      this.files_list.push(name[0])

      let params = {}
      params["school_id"] = schoolId
      params['stage_id'] = this.studentForm.controls["stages"].value;
      params['grade_id'] = this.studentForm.controls["grades"].value;
      params['name'] = name[0]

      const filePath = 'students/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + name[0] + "_original";
      params['url'] = filePath.slice(0, -9)

      const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, fileListA[i]);

      // Upload photo to firestore
      // let fileUpload = await uploadTask.snapshotChanges().toPromise()
      let fileUpload = uploadTask.snapshotChanges().pipe(
        finalize(() => {
          // Assign reference
          this.dataService.uploadImages(params).subscribe(data => {
            this.uploadFilesSimulator(index);
            index += 1

            counter -= 1;
            if(counter == 0) {

              // Upload & assign secondary photos
              for(let i = 0; i < fileListB.length; i++) {
                let name = fileListB[i].name.toUpperCase().split(".")
                this.files_list.push(name[0])

                let params = {}
                params["school_id"] = schoolId
                params['stage_id'] = this.studentForm.controls["stages"].value;
                params['grade_id'] = this.studentForm.controls["grades"].value;
                params['name'] = name[0]

                const filePath = 'students/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + name[0] + "_original";
                params['url'] = filePath.slice(0, -9)

                console.log(filePath)

                const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, fileListB[i]);

                uploadTask.snapshotChanges().pipe(
                  finalize(() => {
                    this.dataService.uploadImages(params).subscribe(data => {
                      this.uploadFilesSimulator(index);
                      index += 1
                    })
                  })
                ).subscribe();
              }
            }
          }, (err: any) => {
            counter -= 1;
            if(counter == 0) {

              for(let i = 0; i < fileListB.length; i++) {
                let name = fileListB[i].name.toUpperCase().split(".")
                this.files_list.push(name[0])

                let params = {}
                params["school_id"] = schoolId
                params['stage_id'] = this.studentForm.controls["stages"].value;
                params['grade_id'] = this.studentForm.controls["grades"].value;
                params['name'] = name[0]

                const filePath = 'students/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + name[0] + "_original";
                params['url'] = filePath.slice(0, -9)

                const storageRef = this.firebaseStorageService.referenciaCloudStorage(filePath);
                const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, fileListB[i]);

                uploadTask.snapshotChanges().pipe(
                  finalize(() => {
                    this.dataService.uploadImages(params).subscribe(data => {
                      this.uploadFilesSimulator(index);
                      index += 1
                    })
                  })
                ).subscribe();
              }
            }
          })

        })
      ).subscribe()

    }




    return;
    /*
    console.log(this.files)
    // this.showPrimarySpinner = true;

    if (this.files.length != 0) {
      // TODO call create user
      // upload to storage
      // this.uploadFilesSimulator(0);
      let index = 0
      for (const item of this.files) {
        let text = item.name.toUpperCase()
        let name = text.split('.')
        console.log(name)
        this.files_list.push(name[0])
        let params = {}
        this.routeSub = this.route.params.subscribe(r => {
          params['school_id'] = r.id_school
        })
        params['stage_id'] = this.studentForm.controls["stages"].value;
        params['grade_id'] = this.studentForm.controls["grades"].value;

        const filePath = 'students/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + name[0] + "_original";
        const storageRef = this.firebaseStorageService.referenciaCloudStorage(filePath);
        const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, item);
        console.log(storageRef.getMetadata())
        uploadTask.snapshotChanges().pipe(
          finalize(() => {
            console.log(filePath)
            params['url'] = filePath.slice(0, -9)
            params['name'] = name[0]
            this.dataService.uploadImages(params).subscribe(data => {
              this.uploadFilesSimulator(index);
              index += 1
            })
          })
        ).subscribe();
      }

    }
    else {
      this.translate.get('alerts.images_required').subscribe(res4 => {
        // this.showPrimarySpinner = false;
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000, panelClass: "error-snackbar" })
        return false;
      })
    }*/
  }

  public async uploadImages2() {

    // Exit if file list is empty
    if(this.files.length<=0) {
      let msg = await this.translate.get('alerts.images_required').toPromise();
      this.snackbar.openFromComponent(CustomPopupComponent, { data: msg, duration: 4000, panelClass: "error-snackbar" });
      return;
    }

    // Separate files by file name (A -> list A , B -> list B)
    const fileList = this.files

    let filesMap: any = {}
    let fileListA = []
    let fileListB = []
    let allFileListB = []
    let nonExistantAB = []
    let schoolId = this.route.snapshot.paramMap.get('id_school')

    fileList.forEach((file: any) => {
      let name = file.name.toUpperCase().split(".")[0]
      filesMap[name] = file

      let isPrimaryPhoto: boolean = file.name.toUpperCase().split(".")[0].slice(-1) == "A"
      isPrimaryPhoto ? fileListA.push(file) : fileListB.push(file)
    })

    console.log(filesMap)

    // Index for visual loading bar
    let index = 0

    // Counter to check when all async methods have finished
    let counter = fileListA.length

    console.log(fileListA.length)

    if(fileListA.length > 0) {
      // Upload & assign primary photos
      for(let i = 0; i < fileListA.length; i++) {
        let name = fileListA[i].name.toUpperCase().split(".")
        this.files_list.push(name[0])

        let params = {}
        params["school_id"] = schoolId
        params['stage_id'] = this.studentForm.controls["stages"].value;
        params['grade_id'] = this.studentForm.controls["grades"].value;
        params['name'] = name[0]

        const filePath = 'students/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + name[0] + "_original";
        params['url'] = filePath.slice(0, -9)

        const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, fileListA[i]);

        // Upload photo to firestore
        // let fileUpload = await uploadTask.snapshotChanges().toPromise()
        let fileUpload = uploadTask.snapshotChanges().pipe(
          finalize(() => {
            // Assign reference
            this.dataService.uploadImages(params).subscribe(data => {
              console.log(name[0])
              console.log(Object.keys(filesMap))
              index = Object.keys(filesMap).indexOf(name[0])
              this.uploadFilesSimulator(index, false);

              counter -= 1;
              if(counter == 0) {

                if(fileListB.length == 0) {
                  let msg = this.translate.instant('alerts.upload_successfull')
                  this.snackbar.openFromComponent(CustomPopupComponent, { data: msg, duration: 4000 })
                }

                // Upload & assign secondary photos
                for(let i = 0; i < fileListB.length; i++) {
                  let name = fileListB[i].name.toUpperCase().split(".")
                  this.files_list.push(name[0])

                  let params = {}
                  params["school_id"] = schoolId
                  params['stage_id'] = this.studentForm.controls["stages"].value;
                  params['grade_id'] = this.studentForm.controls["grades"].value;
                  params['name'] = name[0]

                  const filePath = 'students/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + name[0] + "_original";
                  params['url'] = filePath.slice(0, -9)

                  console.log(filePath)

                  const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, fileListB[i]);

                  uploadTask.snapshotChanges().pipe(
                    finalize(() => {
                      this.dataService.uploadImages(params).subscribe(data => {
                        allFileListB.push(name[0])
                        if(!data || !data.error) {
                          this.uploadFilesSimulator(index, false);
                        }
                        else if(data.error && data.student) {
                          nonExistantAB.push(name[0].slice(0, -1))
                        }
                        index += 1

                        if(nonExistantAB.length == 0) {
                          let msg = this.translate.instant('alerts.upload_successfull')
                          this.snackbar.openFromComponent(CustomPopupComponent, { data: msg, duration: 4000 })
                        }
                        else if(allFileListB.length == fileListB.length && nonExistantAB.length>0) {
                          let msg = ""

                          for(let i = 0; i<nonExistantAB.length; i++) {
                            msg += this.translate.instant("upload_photos.student")+nonExistantAB[i]+this.translate.instant("upload_photos.no_photo")
                          }

                          this.snackbar.openFromComponent(CustomPopupComponent, { data: msg, duration: 8000 })
                        }

                      })
                    })
                  ).subscribe();
                }
              }
            }, (err: any) => {
              console.log(err)
            })

          })
        ).subscribe()
      }
    }
    else {
      // Upload & assign secondary photos
      for(let i = 0; i < fileListB.length; i++) {
        let name = fileListB[i].name.toUpperCase().split(".")
        this.files_list.push(name[0])

        let params = {}
        params["school_id"] = schoolId
        params['stage_id'] = this.studentForm.controls["stages"].value;
        params['grade_id'] = this.studentForm.controls["grades"].value;
        params['name'] = name[0]

        const filePath = 'students/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + name[0] + "_original";
        params['url'] = filePath.slice(0, -9)

        console.log(filePath)

        const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, fileListB[i]);

        uploadTask.snapshotChanges().pipe(
          finalize(() => {
            this.dataService.uploadImages(params).subscribe(data => {
              allFileListB.push(name[0])
              if(!data || !data.error) {
                this.uploadFilesSimulator(index, false);
              }
              else if(data.error && data.student) {
                nonExistantAB.push(name[0].slice(0, -1))
              }
              index += 1

              if(nonExistantAB.length == 0) {
                let msg = this.translate.instant('alerts.upload_successfull')
                console.log(msg)
                this.snackbar.openFromComponent(CustomPopupComponent, { data: msg, duration: 4000 })
              }
              else if(allFileListB.length == fileListB.length && nonExistantAB.length>0) {
                let msg = ""

                for(let i = 0; i<nonExistantAB.length; i++) {
                  msg += this.translate.instant("upload_photos.student")+nonExistantAB[i]+this.translate.instant("upload_photos.no_photo")
                }

                this.snackbar.openFromComponent(CustomPopupComponent, { data: msg, duration: 8000 })
              }
            })
          })
        ).subscribe();
      }
    }
  }

  // This method uploads a list of images directly to firestore, and then makes API call to store said img url in datastore
  private async uploadAndAssignPhotoList(photoList: any[]): Promise<boolean> {
    try{
      let counter = photoList.length;
      let index = 0;

      for(let i = 0; i < photoList.length; i++) {
        let name = photoList[i].name.toUpperCase().split(".")
        this.files_list.push(name[0])

        let params = {}
        params["school_id"] = this.route.snapshot.paramMap.get('id_school')
        params['stage_id'] = this.studentForm.controls["stages"].value;
        params['grade_id'] = this.studentForm.controls["grades"].value;
        params['name'] = name[0]

        const filePath = 'students/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + name[0] + "_original";
        params['url'] = filePath.slice(0, -9)

        const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, photoList[i]);

        // Upload photo to firestore
        let fileUpload = uploadTask.snapshotChanges().pipe(
          finalize(() => {
            // Assign reference
            this.dataService.uploadImages(params).subscribe(data => {
              this.uploadFilesSimulator(index);
              index += 1
              counter -= 1; if(counter==0){ return true; }
            }, (e) => {
              index += 1
              counter -= 1; if(counter==0){ return true; }
            })
          })
        ).subscribe()
      }
    } catch(err){
      console.log(err)
      return false
    }
  }



  selectFile(event, type) {
    if (type == 'primary') {
      this.selectedFiles = event.target.files;
    }
    // else {
    //   this.selectedSecondaryFiles = event.target.files;
    // }

  }

  //--------------Drag and Drop functions-------------//
  /**
     * on file drop handler
     */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.files_list.splice(index, 1)
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number, alert: boolean = true) {
    setTimeout(() => {
      console.log(this.files)
      console.log(this.files_list)
      console.log(index, this.files.length)
      const progressInterval = setInterval(() => {
        if (this.files[index].progress === 100) {
          clearInterval(progressInterval);

          this.files.splice(index, 1)

          if (index === this.files.length - 1) {
            this.translate.get('alerts.upload_successfull').subscribe(res4 => {
              // this.showPrimarySpinner = false;
              
              if (this.files.length > 0) {
                this.files = []
              }

              if(alert) {
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
              }
              //this.router.navigateByUrl(`schools`);
              //this.files = [];
            })
            return;
          }
        } else {
          this.files[index].progress += 20;
        }
      }, 100);

    }, 500);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    let lets_continue = false;
    for (const item of files) {
      let name = item.name.split('.')
      if (name[0].length == 4) {
        if (name[0][0] == '0' || name[0][0] == '1' || name[0][0] == '2' ||
          name[0][0] == '3' || name[0][0] == '4' || name[0][0] == '5' ||
          name[0][0] == '6' || name[0][0] == '7' || name[0][0] == '8' || name[0][0] == '9') {
          if (name[0][1] == '0' || name[0][1] == '1' || name[0][1] == '2' ||
            name[0][1] == '3' || name[0][1] == '4' || name[0][1] == '5' ||
            name[0][1] == '6' || name[0][1] == '7' || name[0][1] == '8' || name[0][1] == '9') {
            if (name[0][2] == '0' || name[0][2] == '1' || name[0][2] == '2' ||
              name[0][2] == '3' || name[0][2] == '4' || name[0][2] == '5' ||
              name[0][2] == '6' || name[0][2] == '7' || name[0][2] == '8' || name[0][2] == '9') {
              if (name[0][3] == 'A' || name[0][3] == 'B' || name[0][3] == 'a' || name[0][3] == 'b') {
                lets_continue = true
              }
            }
          }
        }

      }

    }
    if (lets_continue == true) {
      for (const item of files) {
        item.progress = 0;
        this.files.push(item);
        // let name = item.name.split('.')
        // this.files_list.push(name[0])
        // console.log(item.name)

        //   // upload to storage
        //   let params = {}
        //   this.routeSub = this.route.params.subscribe(r => {
        //     params['school_id'] = r.id_school
        //   })
        //   params['stage_id'] = this.studentForm.controls["stages"].value;
        //   params['grade_id'] = this.studentForm.controls["grades"].value;

        //   const filePath = 'students/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + name[0];
        //   const storageRef = this.firebaseStorageService.referenciaCloudStorage(filePath);
        //   const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, item);
        //   console.log(storageRef.getMetadata())
        //   uploadTask.snapshotChanges().pipe(
        //     finalize(() => {

        //     })
        //   ).subscribe();

      }
      // this.uploadFilesSimulator(0);
    }
    else {
      alert('Formato nombre imagenes incorrecto')
      return false
    }

  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  //-----------------End Drag and Drop----------------//

}
